/**
 * Styled Components - Created by cazarez on 11/04/18.
 */
import styled from 'styled-components'
import { GRAY_DARK } from '../../theme/colors'
import { WHITE } from '../../screens/DesignerTool/constants'
import InfiniteScroll from 'react-infinite-scroller'

export const Container = styled.div`
  background-color: ${WHITE};
  display: flex;
  justify-content: center;
  flex-flow: column;
  align-items: center;
  flex-wrap: wrap;
`

export const Text = styled.div`
  color: ${WHITE};
`

export const ListContainer = styled.div`
  width: 100%;
  display: flex;
  flex-flow: column;
  #counter {
    color: var(--neutral-secondary);
    font: 400 14px/22px var(--font-inter);
    margin-block: var(--spacing-32);
  }
  @media (max-width: 1648px) {
    max-width: 1354px;
  }
  @media (max-width: 1375px) {
    max-width: 1100px;
  }
  @media (max-width: 1224px) {
    max-width: 960px;
  }
  @media (max-width: 1224px) {
    max-width: 890px;
  }
  @media (max-width: 914px) {
    #counter {
      margin-top: var(--spacing-14);
    }
    justify-content: center;
  }
`

export const StyledInfiniteScroll = styled(InfiniteScroll)`
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  justify-content: center;
  gap: var(--spacing-32) var(--spacing-72);
  @media (max-width: 914px) {
    row-gap: var(--spacing-24);
  }
`

export const LoadingContainer = styled.div`
  display: flex;
  height: 12px;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-top: 40px;
`

export const InitialLoadingContainer = styled.div`
  height: 256px;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const TeamStoreContainer = styled.div`
  max-width: 382px;
  width: 100%;
  @media (max-width: 480px) {
    max-width: 100%;
  }
`

export const Notfound = styled.div`
  height: 45px;
  width: 100%;
  color: ${GRAY_DARK};
  font-size: 18px;
  font-weight: 600;
  letter-spacing: 0.23px;
  line-height: 25px;
  text-align: center;
`



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/TeamStoreList/styledComponents.tsx